import {z} from "zod"
import {GraphNode} from "#graph/nodes/graph/node"
import {registerNode} from "#graph/decorators/register-node"
import {FixedValueDefinition} from "#graph/nodes/fixed-value/definition"

@registerNode
export class FixedValue<ValueType> extends GraphNode<ReturnType<typeof FixedValueDefinition<ValueType>>> {
    static nodeClass = "FixedValue"
    static definition = FixedValueDefinition(z.any() as z.ZodSchema)

    override run = async (): Promise<ValueType> => {
        return this.parameters.value!
    }

    override runSync = (): ValueType => {
        return this.parameters.value!
    }
}

@registerNode
export class NumberValue extends FixedValue<number> {
    static override nodeClass = "NumberValue"
    static override definition = FixedValueDefinition(z.number())
}

@registerNode
export class StringValue extends FixedValue<string> {
    static override nodeClass = "StringValue"
    static override definition = FixedValueDefinition(z.string())
}

@registerNode
export class MixedOutput extends FixedValue<{a: number; b: string}> {
    static override nodeClass = "MixedOutput"
    static override definition = FixedValueDefinition(z.object({a: z.number(), b: z.string()}))
}
